import { AvailableActionsMap } from './types'

const actions: AvailableActionsMap = {
  copy: {
    manualAction: true,
    name: 'copy',
    translation: 'copy',
    iconClass: 'fa fa-arrows-h',
    path: 'copy_budget_set_budget_entries_path',
    showPercentage: false,
    available_on: ['account'],
  },

  spread: {
    manualAction: true,
    name: 'spread',
    translation: 'spread',
    iconClass: 'fa fa-arrows-h',
    path: 'spread_budget_set_budget_entries_path',
    showPercentage: false,
    available_on: ['group', 'all'],
  },

  seasonality: {
    manualAction: true,
    name: 'seasonality',
    translation: 'seasonality',
    iconClass: 'i-graph-line',
    path: 'actuals_budget_set_budget_entries_path',
    showPercentage: true,
    available_on: ['account', 'group', 'all'],
  },
}

const actionSelectTabs = {
  MANUAL: 'manual',
}

export { actions, actionSelectTabs }
